import React from "react";
import usePortalCollection from "./usePortalCollection";
import { getCollection } from "services/portalApi";
import { buildPortalUser, selectMembers } from "auth/portalUser";

export default function usePortalData(user) {
  const [reloadImagesUsers, setReloadImagesUsers] = React.useState(false);
  const [userState, setUserState] = React.useState({ access: 1 });
  const [allUsers, setAllUsers] = React.useState([]);
  const [allMembers, setAllMembers] = React.useState([]);
  const [allImages, setAllImages] = React.useState([]);
  const [allTentatives, reloadTentatives] = usePortalCollection("/tentatives", "tentatives");
  const [allProjects, reloadProjects] = usePortalCollection("/projects", "projects");
  const [allStudies, reloadStudies] = usePortalCollection("/studies", "studies");
  const [allRegistrations, reloadRegistrations] = usePortalCollection("/registrations", "registrations");
  const [allAttendance, reloadAttendance] = usePortalCollection("/attendance", "attendance");
  const [allDataRequests] = usePortalCollection("/data_requests", "dataRequests");

  React.useEffect(() => {
    let active = true;
    async function loadIdentityData() {
      const [images, users] = await Promise.all([
        getCollection("/images", "images"),
        getCollection("/users", "users"),
      ]);
      if (!active) return;
      setAllImages(images);
      setAllUsers(users);
      setAllMembers(selectMembers(users));
      setUserState(buildPortalUser(user, users, images));
      setReloadImagesUsers(false);
    }
    loadIdentityData();
    return () => { active = false; };
  }, [reloadImagesUsers, user]);

  return {
    allAttendance, allDataRequests, allImages, allMembers, allProjects,
    allRegistrations, allStudies, allTentatives, allUsers, userState,
    reloadAttendance, reloadProjects, reloadRegistrations, reloadStudies,
    reloadTentatives, setReloadImagesUsers,
  };
}
